import services from 'services/services';
import { SEARCH_CARS_URL } from 'helpers';

import * as types from 'store/types';
import store from 'store/store';
import { searchCarsSelectors } from 'store/selectors';

export const searchCars = (params) => async (dispatch) => {
	try {
		dispatch({
			type: types.SEARCH_CARS_FETCH_DATA_LOADING,
			payload: params
		});

		const state = store.getState();
		const payload = searchCarsSelectors.getMeta(state);

		const {
			data: { data, meta }
		} = await services.post(SEARCH_CARS_URL(params), {
			offsets: payload
		});

		dispatch({
			type: types.SEARCH_CARS_FETCH_DATA_SUCCESS,
			payload: {
				data,
				meta
			}
		});
	} catch (error) {
		dispatch({
			type: types.SEARCH_CARS_FETCH_DATA_ERROR,
			payload: error
		});
	}
};

export const searchMoreCars = () => async (dispatch) => {
	try {
		dispatch({
			type: types.SEARCH_MORE_CARS_FETCH_DATA_LOADING
		});

		const state = store.getState();
		const params = searchCarsSelectors.getParams(state);
		const payload = searchCarsSelectors.getMeta(state);
		const {
			data: { data, meta }
		} = await services.post(SEARCH_CARS_URL(params), { offsets: payload });

		dispatch({
			type: types.SEARCH_MORE_CARS_FETCH_DATA_SUCCESS,
			payload: {
				data,
				meta
			}
		});
	} catch (error) {
		dispatch({
			type: types.SEARCH_MORE_CARS_FETCH_DATA_ERROR,
			payload: error
		});
	}
};
